import { Ref, ref } from "vue";
import { defineStore } from "pinia";
import { Storage } from "@/uitls/Storage";
import { imykLogin, imFastLogin } from "@/api/im/index";
import { apiUserLogin, apiYkLogin } from "@/api/php/user";
import { Toast } from "vant";
import Platform from "@/config/platform";
import { IMUser, Convert } from "@/model/imUser";
import { deviceid, YMPush, formatDate, checkLoginEvent } from "@/uitls/uitls";
import { encryptionConfig } from "@/api/php/serverConfig";
import indexDB from "@/network/db/dexieDb";
import EventBus from "@/uitls/EventBus";

export const usePiniaState = defineStore("user", () => {
  //登录了没？ 
  const isLogin = ref(false);
  //是不是游客
  const isYk = ref(false);
  //签到了没
  const isQD = ref(false)

  const user = ref({}) as Ref<IMUser>;

  //检查今天签到了吗
  const checkQD = () => {
    const time = new Date().getTime()
    //今天的日期
    const day = formatDate(time)
    const jfDay = Storage.get("jfStoreDay");
    if (jfDay && jfDay == day) {
      isQD.value = true;
    }
  }
  //去登录  isEveBus是否登录完成需要通知
  const toLogin = async () => {
    
    if (isLogin.value) {
      return;
    }
    checkQD()

    //先拿到uid和fastkey
    const uid = Storage.get("uid");
    const fastkey = Storage.get("fastkey");
    if (uid && uid != "" && fastkey && fastkey != "") {
      //是正式用户
      await fastLogin(fastkey);
    } else {
      //是游客
      await ykLogin();
    }
    await getConfig()
  };

  const getConfig = async () => {
    const res: any = await encryptionConfig()
    Platform.downUrl = res.data.download_url;
  }

  const fastLogin = async (fastkey: string) => {
    //正式用户登录
    const result: any = await imFastLogin({ uno: "", fastkey });
    
    if (result.ret == 0) {
      loginSuccess(result);
    } else {
      //账号登录失败。转成游客登录
      Storage.remove("phone")
      Storage.remove("fastkey")
      ykLogin();
    }
    // imFastLogin
  };

  //正式用户登录成功
  const loginSuccess = (data: any, inInitSocket: boolean = false) => {

    
    const iMUserModel = Convert.toIMUserModel(JSON.stringify(data));
    user.value.fid = iMUserModel.user.fid;
    user.value.nickName = iMUserModel.user.nickname;
    user.value.phone = iMUserModel.user.phonenum;
    user.value.zone = iMUserModel.user.zone || '86';
    user.value.fastkey = iMUserModel.fastkey;
    user.value.avatar = iMUserModel.user.headurl;
    user.value.uid = iMUserModel.user.uid;
    user.value.usertype = iMUserModel.user.usertype;
    user.value.fname = iMUserModel.user.fname;
    user.value.email = iMUserModel.user.email;
    user.value.socketIp = [];
    for (let i = 0; i < iMUserModel.server.length; i++) {
      user.value.socketIp.push(iMUserModel.server[i].svrip);
    }
    user.value.socketPort = [];
    for (let i = 0; i < iMUserModel.server.length; i++) {
      user.value.socketPort.push(iMUserModel.server[i].websvrport);
    }

    user.value.sign = iMUserModel.user.sign;
    isLogin.value = true;

    Storage.set("fid", user.value.fid);
    Storage.set("uid", user.value.uid);
    Storage.set("fastkey", user.value.fastkey);
    console.log('login success', user.value.nickName);
    
    if ((user.value.phone && user.value.phone.length > 3) || (user.value.fname && user.value.fname.length > 3)) {
      isYk.value = false;
      Storage.set("phone", user.value.phone);

      if (Platform.client == "h5") {
        phpLogin(inInitSocket);
        if(user.value.fname.length < 1){
            EventBus.emit("showSetNickName");
        }
      } else {
        //是原生，直接连接socket
        toSocket()
      }
    } else {
      isYk.value = true;
      if (Platform.client == "h5") {
        phpYkLogin()
      } else {
        toSocket()
      }
    }

    console.log('is YK:', isYk.value);

    checkLoginEvent(); // 登录成功, 检查登录时间, 是否需要打点上报
  };
  //是原生，直接连接socket,不php登录
  const toSocket = () => {
    const str = window.location.href
    //只有是直播间里面，才会连接socket
    if (str.indexOf('/player') != -1 || str.indexOf('/mnightplayer') != -1) {
      const url = `wss://${user.value.socketIp}:${user.value.socketPort}`;
      if (!window.$Socket.ws) {
        indexDB.init();
        window.$Socket.preInit(user.value.socketIp, user.value.socketPort, user.value.uid, user.value.fastkey);
      }
    }

  }

  //php正式用户登录
  const phpLogin = async (inInitSocket) => {

    
    const res: any = await apiUserLogin({
      phone: user.value.phone,
      fastkey: user.value.fastkey,
      uid: user.value.uid,
      fname: user.value.fname,
    });

    if (res.code == "200") {
      console.log('res.data', res.data);
      user.value.customerId = res.data.customer_id;
      user.value.token = res.data.token;
      Storage.set("meAnchor", res.data.free_data.user.usertype);
      if (!window.$Socket.ws) {
        indexDB.init();
        window.$Socket.preInit(user.value.socketIp, user.value.socketPort, user.value.uid, user.value.fastkey);
      }
      if (inInitSocket) {
        // console.log("重新连接了");
        // window.$Socket.ws.close();
        window.$Socket.ws = null;
        indexDB.init();
        window.$Socket.preInit(user.value.socketIp, user.value.socketPort, user.value.uid, user.value.fastkey);
      }
      Storage.set("customerId", user.value.customerId);
      Storage.set("check_id", user.value.customerId);
      Storage.set("check_type", 2);
      Storage.set("token", user.value.token);
      YMPush('MAIN', '登录成功')

      window.$apiNet.statisticsPost({ action_id: '28' });
      EventBus.emit("phpLoginSuccessNotification");
      
    } else {
      YMPush('MAIN', '登录失败')
      console.log('登录失败：', res.msg);

      Toast.fail(res.msg);
    }
  };

  //php游客登录
  const phpYkLogin = async () => {
    // window.location.href
    const res: any = await apiYkLogin({
      phone_code: deviceid("deviceid"),
      url: window.location.href,
      uid: user.value.uid,
    });

    if (res.code == 200) {
      console.log('identifier', res.data.identifier);

      Storage.set("identifier", res.data.identifier);
      Storage.set("check_id", res.data.identifier);
      Storage.set("check_type", 1);
      user.value.identifier = res.data.identifier
      user.value.token = res.data.token;
      window.$Socket.ws = null;
      window.$Socket.preInit(user.value.socketIp, user.value.socketPort, user.value.uid, user.value.fastkey);

      indexDB.init();
      YMPush('MAIN', '登录成功')
      window.$apiNet.statisticsPost({ action_id: '28' });
    } else {
      YMPush('MAIN', '登录失败')
      Toast.fail(res.msg);
    }
  };

  //游客登录
  const ykLogin = async (onlineDb = false) => {
    // online重连db
    
    const result = await imykLogin();
    // userData.value.avatar
    const iMUserModel = Convert.toIMUserModel(JSON.stringify(result));
    console.log("游客登录", result);

    
    if (iMUserModel.ret == 0) {
      //登录成功
      user.value.fid = iMUserModel.user.fid;
      user.value.nickName = iMUserModel.user.nickname;
      user.value.phone = iMUserModel.user.phonenum;
      user.value.zone = iMUserModel.user.zone || '86';
      user.value.fastkey = iMUserModel.fastkey;
      user.value.avatar = iMUserModel.user.headurl;
      user.value.uid = iMUserModel.user.uid;

      user.value.socketIp = [];
      for (let i = 0; i < iMUserModel.server.length; i++) {
        user.value.socketIp.push(iMUserModel.server[i].svrip);
      }
      user.value.socketPort = [];
      for (let i = 0; i < iMUserModel.server.length; i++) {
        user.value.socketPort.push(iMUserModel.server[i].websvrport);
      }

      isLogin.value = true;
      Storage.set("uid", user.value.uid);
      // Storage.remove("fastkey")
      Storage.set('fastkey', user.value.fastkey)
      Storage.remove("customerId")
      Storage.remove("token")
      indexDB.init();

      if ((user.value.phone && user.value.phone.length > 3) || (user.value.fname && user.value.fname.length > 3)) {
        isYk.value = false;
      } else {
        isYk.value = true;
      }

      console.log('is YK:', isYk.value);
      
      phpYkLogin();

      checkLoginEvent(); // 登录成功, 检查登录时间, 是否需要打点上报
    } else {
      //登录失败
      Toast.fail("err");
    }
  };

  // 退出登录
  const exituser = (retainDeviceID: boolean = false) => {
    isLogin.value = false;
    window.$Socket.ws = null;
    
    let DEVICE_ID = Storage.get('DEVICE_ID');
    const lastPopupTime = Storage.get("lastPopupTime");
    Storage.clear()
    Storage.set("newGuide", '1');
    Storage.set("showRb", "1111");
    Storage.set("xieyi", "1111");
    if (retainDeviceID) { // 是否保留设备ID
      Storage.set('DEVICE_ID', DEVICE_ID);
    }
    Storage.set('lastPopupTime', lastPopupTime);
    // ykLogin();
  };

  // 修改昵称
  const Revisename = (name) => {
    user.value.nickName = name;
  }

  // 设置用户信息
  const changeAccountInfo = (fname: string, nickName: string, email: string) => {
    
    if(fname && fname.length>0){
      user.value.fname = fname;
    }
    if(nickName && nickName.length>0){
      user.value.nickName = nickName;
    }
    if(email && email.length>0){
      user.value.email = email;
    }
  }

  return { user, isLogin, isYk, toLogin, loginSuccess, exituser, Revisename, isQD, changeAccountInfo };
});
